module.exports = __webpack_public_path__ + "static/media/ignacio.e8437b39.jpg";